import { Field, FieldError, FieldLabel } from "@/ds/shadcn/components/ui/field";
import { Select, SelectTrigger, SelectContent, SelectValue } from "@/ds/shadcn/components/ui/select";
import { useFieldContext } from "@/lib/form/useAppForm";
import { useMemo, type FC, type PropsWithChildren } from "react";

export interface SelectFieldProps extends PropsWithChildren {
	label: string;
}

export const SelectField: FC<SelectFieldProps> = props => {
	const {
		label,
		children
	} = props;

	const field = useFieldContext<string>();

	const error = useMemo(() => {
		if (field.state.meta.errors.length < 1 || !field.state.meta.isBlurred || !field.state.meta.isDirty) {
			return null;
		}

		return field.state.meta.errors[0];
	}, [field.state.meta.errors, field.state.meta.isBlurred, field.state.meta.isDirty]);

	return (
		<Field data-invalid={!!error}>
			<FieldLabel htmlFor={field.name}>{label}</FieldLabel>

			<Select value={field.state.value} onValueChange={field.handleChange} disabled={field.form.state.isSubmitting}>
				<SelectTrigger id={field.name} className="w-full">
					<SelectValue placeholder="Select..." />
				</SelectTrigger>
				<SelectContent>
					{children}
				</SelectContent>
			</Select>

			{
				error && <FieldError>{error.message}</FieldError>
			}
		</Field>
	);
};
